import angular from 'angular';

module.exports = angular.module('common.filters.currency', [])
.filter('currency', function(numberFilter) {
  return function(cents, decimals, defaultValue = '—', symbol = '$') {
    if (cents !== null && isFinite(cents)) {
      if (decimals === -3) {
        return symbol + numberFilter(cents / 100000, 0) + 'K';
      } else {
        return symbol + numberFilter(cents / 100, decimals || 0);
      }
    } else {
      return defaultValue;
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/currency.js
 **/